export default __webpack_public_path__ + "static/media/day_rain.a8fcbfd2.svg";